import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import logoSrc from '../../../assets/logo_with_label.png'
import './AuthCard.css'

interface AuthCardProps {
  title: string
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
}

// общая оболочка страниц входа и восстановления пароля
export default function AuthCard({ title, subtitle, children, footer }: AuthCardProps) {
  const { t } = useTranslation()

  return (
    <div className="dealer-auth">
      <div className="dealer-auth__card">
        <div className="dealer-auth__brand">
          <img src={logoSrc} alt="Verrafied" className="dealer-auth__logo" />
          <span className="dealer-auth__portal">{t('dealer.portal_name')}</span>
        </div>
        <h1 className="dealer-auth__title">{title}</h1>
        {subtitle && <p className="dealer-auth__subtitle">{subtitle}</p>}
        <div className="dealer-auth__body">{children}</div>
        {footer && <div className="dealer-auth__footer">{footer}</div>}
      </div>
    </div>
  )
}
